import { useTranslation } from 'react-i18next';
import './style.css';

const FinalConfirmation = ({ onSubmit, isLoading }) => {
    const { t } = useTranslation();

    return (
        <div className="final-confirmation-section">
            <div className="final-confirmation-info-card">
                <div className="final-confirmation-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <polyline points="22 4 12 14.01 9 11.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="final-confirmation-info-text">
                    <h3 className="final-confirmation-info-title">{t('final-confirmation')}</h3>
                    <p className="final-confirmation-info-description">
                        {t('confirm-patient-arrival-initiate-medical-procedure')}
                    </p>
                </div>
            </div>


        </div>
    );
};

export default FinalConfirmation;

